// src/utils/apiFetch.js

export async function apiFetch(url, options = {}) {
    const token = localStorage.getItem('token');
    const apiUrl = process.env.REACT_APP_API_URL;
  
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(options.headers || {})
    };
  
    const config = {
      ...options,
      credentials: 'include', // include cookies for refresh token
      headers,
    };
  
    let response = await fetch(url, config);
  
    if (response.status === 401) {
      console.warn('[apiFetch] Access token expired. Attempting refresh...');
  
      const refreshRes = await fetch(`${apiUrl}/refresh-token`, {
        method: 'POST',
        credentials: 'include'
      });
  
      if (refreshRes.ok) {
        // Optionally update token here if server responds with a new one
        // const data = await refreshRes.json();
        // localStorage.setItem('token', data.access_token);
  
        response = await fetch(url, config); // Retry original request
      } else {
        console.error('[apiFetch] Token refresh failed — session likely expired');
        throw new Error('Session expired. Please log in again.');
      }
    }
  
    return response;
  }
  
  